<script>
import moment from 'moment'
import visibilityOnIcon from '@/assets/images/icons/visibility-on.svg?inline'
import visibilityOffIcon from '@/assets/images/icons/visibility-off.svg?inline'
import {
  rexText,
  rexTextarea
} from '@/components/views/rexField'
import {
  rexRoundedAutocomplete,
  rexRoundedSingleSelect,
  rexRoundedDate,
  rexRoundedTourist
} from '@/components/views/rexRoundedField'
import { durations } from '@/utils/constants'

export default {
  name: 'sale-form',
  components: {
    visibilityOnIcon,
    visibilityOffIcon,
    rexRoundedAutocomplete,
    rexRoundedSingleSelect,
    rexRoundedTourist,
    rexRoundedDate,
    rexTextarea,
    rexText
  },
  data: () => ({
    image: null,
    services: [
      {
        slug: 1,
        name: 'hotel'
      },
      {
        slug: 17,
        name: 'tour',
      }
    ]
  }),
  computed: {
    durations() {
      return durations
    },
    modalForm() {
      return this.$store.getters['sale/getModalForm']
    },
    isFormLoading() {
      return this.$store.getters['sale/isModalFormLoading']
    },
    isImageUploading() {
      return this.$store.getters['sale/isImageUploading']
    },
    form() {
      return this.$store.getters['sale/getEditForm']
    },
    currentSaleId() {
      return this.$store.getters['sale/editableNowSaleId']
    },
    datepickersRange: () => ({
      minDate: moment().toDate(),
      maxDate: moment().add(3, 'years').toDate()
    }),
    visibilitySettingsType: {
      get() {
        return this.$store.getters['sale/getVisibilitySettingsType']
      },
      set(value) {
        this.$store.commit('sale/setVisibilitySettingsType', value)
      }
    },
    service: {
      get() {
        const serviceId = this.$store.getters['sale/getField']('editForm.serviceId')

        return this.services.find(item => item.slug === serviceId).name
      },
      set(data) {
        const value = this.services.find(item => item.name === data).slug

        this.$store.commit('sale/setField', {
          target: 'editForm.serviceId',
          value
        })
      }
    },
    isActive: {
      get() {
        return this.$store.getters['sale/getField']('editForm.isActive')
      },
      set(value) {
        this.$store.commit('sale/setField', {
          target: 'editForm.isActive',
          value
        })
      }
    },
    imageSrc: {
      get() {
        return this.$store.getters['sale/getField']('editForm.imageSrc')
      },
      set(value) {
        this.$store.commit('sale/setField', {
          target: 'editForm.imageSrc',
          value
        })
      }
    },
  },
  methods: {
    getYesterdayDate() {
      return moment(new Date()).add(-1, 'days').toDate()
    },
    handleImageUpload(image) {
      this.$store.dispatch('sale/uploadImage', image)
    },
    resetDateAndShift() {
      this.$store.commit('sale/resetDateAndShift')
    },
    close() {
      this.$store.commit('sale/updateModalForm', {
        active: false,
        mode: null
      })

      this.$store.commit('sale/clearEditForm')
      this.imageSrc = null
    },
    create() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('sale/createSale', this.form)
        }
      })
    },
    update() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('sale/updateSale', {
            id: this.currentSaleId,
            data: this.form
          })
        }
      })
    },
    remove() {
      this.$store.commit('sale/updateIsModalFormLoading', true)
      this.$store.dispatch('sale/removeSale', this.currentSaleId)
    }
  }
}
</script>

<template>
  <div class="card">
    <div
      class="sale-form"
      :class="{
        'sale-form--show-message': modalForm.message
      }"
    >
      <b-loading
        v-if="isFormLoading"
        :is-full-page="false"
        :active="isFormLoading"
      />
      <p
        v-if="modalForm.message"
        class="sale-form__message"
      >
        {{ modalForm.message }}
      </p>
      <div
        v-if="!isFormLoading && modalForm.showContent"
      >
        <div class="sale-form__header">
          <h1>
            {{
              modalForm.mode === 'new'
                ? 'Новоe предложениe'
                : 'Редактирование предложения'
            }}
          </h1>
          <div class="sale-form__header-controls">
            <div class="sale-form__type-switcher">
              <p
                class="sale-form__type-switcher-label"
                :class="{
                  'sale-form__type-switcher-label--active': service === 'tour'
                }"
              >
                Тур
              </p>
              <b-switch
                v-model="service"
                size="is-small"
                true-value="hotel"
                false-value="tour"
              />
              <p
                class="sale-form__type-switcher-label"
                :class="{
                  'sale-form__type-switcher-label--active': service === 'hotel'
                }"
              >
                Отель
              </p>
            </div>
            <button class="sale-form__visibility-switcher">
              <visibility-on-icon
                v-if="isActive"
                @click="isActive = 0"
              />
              <visibility-off-icon
                v-else
                @click="isActive = 1"
              />
            </button>
          </div>
        </div>
        <div
          class="sale-form__basic"
          :class="{
            'sale-form__basic--tour': service === 'tour'
          }"
        >
          <div v-if="service === 'tour'">
            <rex-rounded-autocomplete
              store-module="sale"
              getter-name="getField"
              setter-name="setField"
              target="editForm.placeFrom"
              endpoint="toursOrigins"
              placeholder="Город вылета"
              :show-label="false"
              name="toursOrigins"
              :validate="{
                required: true,
                autocomplete: true
              }"
            />
          </div>
          <div>
            <rex-rounded-autocomplete
              store-module="sale"
              getter-name="getField"
              setter-name="setField"
              target="editForm.placeTo"
              :endpoint="service === 'tour' ? 'toursDestinations' : 'hotelsPlaces'"
              placeholder="Город/курорт/место/гостиница"
              :show-label="false"
              name="destinations"
              :validate="{
                autocomplete: form.placeTo,
                required: true
              }"
            />
          </div>
          <div>
            <rex-rounded-single-select
              store-module="sale"
              getter-name="getField"
              setter-name="setField"
              target="editForm.duration"
              :hide-if-empty="false"
              :show-label="false"
              :data="durations"
            />
          </div>
          <div>
            <rex-rounded-tourist
              store-module="sale"
              getter-name="getField"
              setter-name="setField"
              target="editForm.rooms"
              :tourist-index="0"
              :show-label="false"
            />
          </div>
        </div>
        <div class="sale-form__additional">
          <rex-textarea
            name="description"
            store-module="sale"
            setter-name="setField"
            getter-name="getField"
            target="editForm.description"
            label="Описание пользовательское"
            :validate="{
              max: 180
            }"
          />
          <div>
            <h3 class="rex-field--label">
              Настройки показа
            </h3>
            <div class="sale-form__visibility-settings">
              <div
                class="sale-form__visibility-settings-item"
                :class="{
                  'sale-form__visibility-settings-item--disabled':
                    visibilitySettingsType !== 'dateOnly'
                }"
              >
                <b-radio
                  v-model="visibilitySettingsType"
                  native-value="dateOnly"
                  @input="resetDateAndShift"
                />
                <div>
                  <h3 class="sale-form__visibility-settings-label">
                    Постоянная дата
                  </h3>
                  <rex-rounded-date
                    store-module="sale"
                    setter-name="setField"
                    getter-name="getField"
                    target="editForm.searchDate"
                    position="is-bottom-left"
                    :disabled="visibilitySettingsType !== 'dateOnly'"
                  />
                </div>
              </div>
              <div
                class="sale-form__visibility-settings-item"
                :class="{
                  'sale-form__visibility-settings-item--disabled':
                    visibilitySettingsType !== 'shiftOnly'
                }"
              >
                <b-radio
                  v-model="visibilitySettingsType"
                  native-value="shiftOnly"
                  @input="resetDateAndShift"
                />
                <h3 class="sale-form__visibility-settings-label">
                  Сдвиг
                </h3>
                <rex-text
                  name="shiftOnly"
                  store-module="sale"
                  setter-name="setField"
                  getter-name="getField"
                  target="editForm.extraDays"
                  type="number"
                  :validate="visibilitySettingsType === 'shiftOnly'
                    ? { required: true, minValue: 1 }
                    : {}
                  "
                  :disabled="visibilitySettingsType !== 'shiftOnly'"
                />
              </div>
              <div
                class="sale-form__visibility-settings-item"
                :class="{
                  'sale-form__visibility-settings-item--disabled':
                    visibilitySettingsType !== 'dateWithShift'
                }"
              >
                <b-radio
                  v-model="visibilitySettingsType"
                  native-value="dateWithShift"
                  @input="resetDateAndShift"
                />
                <h3 class="sale-form__visibility-settings-label">
                  Сдвиг не раньше даты
                </h3>
                <div class="sale-form__visibility-settings-double">
                  <rex-rounded-date
                    store-module="sale"
                    setter-name="setField"
                    getter-name="getField"
                    target="editForm.searchDate"
                    position="is-bottom-left"
                    :disabled="visibilitySettingsType !== 'dateWithShift'"
                  />
                  <rex-text
                    name="dateWithShift"
                    store-module="sale"
                    setter-name="setField"
                    getter-name="getField"
                    target="editForm.extraDays"
                    type="number"
                    :validate="visibilitySettingsType === 'dateWithShift'
                      ? { required: true, minValue: 1 }
                      : {}
                    "
                    :disabled="visibilitySettingsType !== 'dateWithShift'"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <h3 class="rex-field--label">
              Изображение
            </h3>
            <div class="sale-form__image-upload">
              <img
                v-if="imageSrc && !isImageUploading"
                :src="imageSrc"
              >
              <b-upload
                v-model="image"
                drag-drop
                accept="image/jpeg,image/png"
                :loading="isImageUploading"
                :disabled="isImageUploading"
                @input="handleImageUpload"
              >
                <section
                  v-if="!isImageUploading"
                  class="section"
                >
                  <div
                    v-if="image || imageSrc"
                    class="content has-text-centered"
                  >
                    <p>Вы можете загрузить другое изображение просто перетащив его сюда</p>
                  </div>
                  <div
                    v-else-if="!imageSrc"
                    class="content has-text-centered"
                  >
                    <p>Нажмите на кнопку ниже</p>
                    <p class="rex-button
                    rex-button--filled rex-button--filled-red"
                    >
                      Загрузить изображение
                    </p>
                    <p>
                      или просто перетащите изображение сюда
                    </p>
                  </div>
                </section>
              </b-upload>
            </div>
          </div>
          <div>
            <div class="sale-form__additional-item">
              <rex-rounded-date
                store-module="sale"
                setter-name="setField"
                getter-name="getField"
                target="editForm"
                range-start-date-name="validityFrom"
                range-end-date-name="validityTo"
                position="is-bottom-left"
                :is-range-picker="true"
                :range="true"
                :years-range="[-10, 10]"
                :min-date="datepickersRange.minDate"
                :max-date="datepickersRange.maxDate"
                label="Сроки показа, от/до"
              />
            </div>
            <rex-textarea
              name="comment"
              store-module="sale"
              setter-name="setField"
              getter-name="getField"
              target="editForm.comment"
              label="Комментарий для сотрудников"
              css-class="sale-form__comment-field"
              :validate="{
                max: 300
              }"
            />
          </div>
        </div>
        <div class="sale-form__footer">
          <button
            class="rex-button rex-button--filled rex-button--filled-grey"
            @click="remove"
          >
            Удалить
          </button>
          <div class="sale-form__footer-item">
            <button
              class="rex-button rex-button--glass rex-button--glass-red"
              @click="close"
            >
              Отмена
            </button>
            <button
              v-if="modalForm.mode === 'new'"
              class="rex-button rex-button--filled rex-button--filled-red"
              @click="create"
            >
              Создать
            </button>
            <button
              v-else
              class="rex-button rex-button--filled rex-button--filled-red"
              @click="update"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>